module.exports = __webpack_public_path__ + "media/LCKV-landing-slow.07484475.mp4";